import { styled } from '@spazious/dollhouse-theme';

export interface LoaderProps {
  dataInterpolation?: (p: number) => string;
  initialState?: (active: boolean) => boolean;
}

export interface LoaderContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  active?: boolean;
}
export const LoaderContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['active'].includes(prop),
  displayName: 'LoaderContainer',
})<LoaderContainerProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--spz-sys-color-surface);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 300ms ease;
  pointer-events: none;
  opacity: ${({ active = true }) => (active ? 1 : 0)};
`;

export default LoaderContainer;
